import {
    calcularQuantidadeDependentes65anos,
    retornaLabelDoValorParentesco,
    validatorEstrtutura1,
    validatorParentescoEmDuplicidade,
    validatorPossui10Dependentes
} from './funcoesAuxiliaresZISF';

export class CorrenteEdicaoZISF {
    constructor(
        dependentes,
        parentesco,
        categorias,
        valoresForm,
        valoresAnterioresForm,
        idadeAssociado
    ) {
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.valoresAnterioresForm = valoresAnterioresForm;
        this.idadeAssociado = idadeAssociado;
    }

    possui2DependentesMaiorIgual65Anos() {
        const edicao = true;

        if (calcularQuantidadeDependentes65anos(this.dependentes, this.idadeAssociado, this.valoresForm, edicao)) {
            this.arrayMsgsErro.push(['', 'O plano ZELO IDEAL SAF permite apenas 2 dependentes com idade maior ou igual a 65 anos.']);
        }

        return this;
    }

    dependentesDentroDaEstrutura1() {
        if (validatorEstrtutura1(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push(['', 'O plano ZELO IDEAL SAF permite somente dependentes do tipo cônjuge, pai, mãe, sogro, sogra, filhos de até 30 anos']);
        }

        return this;
    }

    possui10Dependentes() {
        if (validatorPossui10Dependentes(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('O plano ZELO IDEAL SAF permite apenas 10 dependentes');
        }

        return this;
    }

    parentescoEmDuplicidade() {
        if (validatorParentescoEmDuplicidade(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push(['', `${retornaLabelDoValorParentesco(this.parentesco)}`]);
        }

        return this;
    }
}
